<template>
  <div class="tan px_kcadd">
    <div class="px_add_con">
      <div class="h370 rdiv">
        <h3>选择文章</h3>
        <div class="add_kc_search">
          <input name="" type="button" class="btn_s" @click="getList(filter, excludeIdsArr)"/><input name="" type="text" class="text_put" v-model="filter.title" @keyup.13="getList(filter, excludeIdsArr)"/>
        </div>
        <a href="javascript:void(0);" class="close" @click="$emit('close')"></a>
        <p>没有合适的文章？您可以<a @click="addNew" style="cursor: pointer">创建新文章</a></p>
        <div class="h295">
          <table width="710" border="0" cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <td width="15%"><input type='checkbox' :checked="(selected.length === data.length) && data.length != 0" @click='checkedAll()'></td>
              <td width="85%">文章名称</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in data" :key="item.id">
              <td>
                <input type="checkbox" :value="item.id" :checked="selected.indexOf(item.id)>=0" @click='checkedOne(item.id)' />
              </td>
              <td>{{item.title}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="clear"></div>
      <div class="modalPagination">
        <Paginate :click-handler="clickCallback" :page-count=pages
                  :container-class="'pagination-center'" :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                  :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                  :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                  :first-last-button=$global.paginationOptions.first_last_button
                  :active-class=$global.paginationOptions.active_class
                  :disabled-class=$global.paginationOptions.disabled_class
                  :first-button-text=$global.paginationOptions.first_button_text
                  :last-button-text=$global.paginationOptions.last_button_text
                  :prev-text=$global.paginationOptions.prev_text
                  :next-text=$global.paginationOptions.next_text></Paginate>
      </div>
      <div class="w240 wrap">
        <input name="" type="button" value="确定" class="all_btn" @click="setSelected" />
        <input name="" type="button" value="取消" @click="$emit('close')" class="all_btn color_hui" />
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
  import Bus from '@/utils/bus'
  import utils from '@/utils'
  export default {
    components: { Paginate },
    computed: {
      isEdit () {
        return this.ids && this.ids.length > 0
      }
    },
    mounted () {
      this.getList(this.filter, this.excludeIdsArr)
    },
    data () {
      return {
        data: [],
        pages: 0,
        selected: [],
        filter: {
          pageNo: 1,
          pageSize: 5,
          type: '',
          excludedIds: []
        },
        excludeIdsArr: this.ids,
        isCheckedAll: false,
        prefix: this.$route.meta.prefix || ''
      }
    },
    props: ['ids'],
    methods: {
      clickCallback (pageNum)  {
        this.filter.pageNo = pageNum
        this.getList(this.filter, this.excludeIdsArr)
      },
      getList (filter, list) {
        this.selected = []
        if (list && list.length > 0) {
          filter.excludedIds = list
        }
        var that = this
        api.post(config.bylApiPath, '/knowledgeInfo/findList', filter, function (r) {
          if (r.data && r.data.length>0) {
            that.data = r.data
          } else {
            that.data = []
          }
          that.pages = Math.ceil(r.cntData / that.filter.pageSize) // 页数
        }, function (err) {
          that.$toasted.show(err)
        })
      },
      checkedOne (id) {
        let idIndex = this.selected.indexOf(id)
        if (idIndex >= 0) {
          this.selected.splice(idIndex, 1)
        } else {
          this.selected.push(id)
        }
      },
      checkedAll () {
        this.isCheckedAll = !this.isCheckedAll
        if (this.isCheckedAll) {
          this.selected = []
          if (this.data.length>0) {
            for (var i = 0; i<this.data.length; i++) {
              this.selected.push(this.data[i].id)
            }
          }
        } else {
          this.selected = []
        }
      },
      setSelected () {
        Bus.$emit('set-selected-kb', this.excludeIdsArr.concat(this.selected))
        this.$emit('close')
      },
      addNew () {
        this.$router.push({path: this.prefix + '/org/repo/create'})
      }
    }
  }
</script>

<style scoped>
  input[type=checkbox] {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/repo/select.vue